import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Modal from 'react-modal'
import Button from '../../components/Button'

const Bag = ({ items, isLoggedUser }) => {
    const [state, setState] = useState({
        open: false,
        item: null
    })

    const itemNames = []

    items.forEach(item => {
        itemNames.push(item.name)
    })

    const { open, item } = state

    let uniqueNameItems = [...new Set(itemNames)];
    let returnItems = uniqueNameItems.map(value => [items.find(item => item.name === value), itemNames.filter(str => str === value).length])

    return (
        <div className='mb-8'>
            <h2 className='full-width'>Mochila</h2>
            <article className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 mb-12 justify-center items-center'>
                {!items.length ?
                    <div className='col-span-3'>
                        {isLoggedUser ?
                            <>
                                <h4 className='pb-2'>Ainda não tem quaisquer itens na sua mochila!</h4>
                                <p className='mb-4'>Para encontrar novos itens jogo o Mundo em Notícias, que pode encontrar no menu lateral ou ao carregar no botão abaixo</p>
                                <Link to='/mundo-em-noticias'>
                                    <Button className='mr-0'>
                                        Ir para Mundo em Notícias
                                    </Button>
                                </Link>
                            </>
                            :
                            <p>Este utilizador não tem qualquer tipo de item na sua mochila!</p>
                        }
                    </div>
                    :
                    returnItems.map((item, index) =>
                        <Button
                            key={index}
                            onClick={() => setState({ open: !open, item: item })}
                            className="p-6 overflow-hidden flex flex-col flex-wrap image-button usable h-full"
                        >
                            <img className='mx-auto pb-2' alt={item[0].name} title={item[0].name} src={require(`../../assets/img/items/${item[0].img}.png`)} />
                            <h3 className='pb-2'>{item[0].name}</h3>
                            <p className='text-sm'>Quantidade: {item[1]}</p>
                        </Button>
                    )
                }
                {item &&
                    <Modal
                        isOpen={open}
                        contentLabel="Modal de item individual"
                        className='modal'
                        ariaHideApp={false}
                        closeTimeoutMS={300}
                        shouldCloseOnOverlayClick={true}
                        onAfterClose={() => setState({ ...state, item: null })}
                        onRequestClose={() => setTimeout(() => {
                            setState({ ...state, open: !open })
                        }, 300)}
                    >
                        <div className='modal-guts'>
                            <div className='flex flex-wrap justify-between items-center'>
                                <h2>{item[0]?.name}</h2>
                            </div>
                            <div className='grid grid-cols-1 lg:grid-cols-2'>
                                <img
                                    className='object-contain h-48 w-full'
                                    alt={item[0]?.name}
                                    title={item[0]?.name}
                                    src={require(`../../assets/img/items/${item[0]?.img}.png`)}
                                />
                                <div>
                                    <p className='pb-2'><b>Descrição:</b> {item[0]?.description}</p>
                                    <p className='pb-2'><b>Quantidade:</b> {item[1]}</p>
                                </div>
                            </div>
                            <div className='pt-5 flex justify-end'>
                                <Button
                                    className='mr-0'
                                    onClick={() => setTimeout(() => {
                                        setState({ ...state, open: !open })
                                    }, 300)}
                                >
                                    Fechar
                            </Button>
                            </div>
                        </div>
                    </Modal>
                }
            </article>
        </div >
    )
}

export default Bag
